import { render, staticRenderFns } from "./MailSentChip.vue?vue&type=template&id=5df30952&"
import script from "./MailSentChip.vue?vue&type=script&lang=js&"
export * from "./MailSentChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports